import { combineReducers } from '@reduxjs/toolkit';
import admins from 'redux/reducers/admins/reducer';
import advertising from 'redux/reducers/advertising/reducer';
import aiChatBots from 'redux/reducers/ai-chat-bot/reducer';
import aiPrompts from 'redux/reducers/ai-prompts/reducer';
import aiServicese from 'redux/reducers/ai-services/reducer';
import apkFiles from 'redux/reducers/apk-files/reducer';
import app from 'redux/reducers/app/reducer';
import auth from 'redux/reducers/auth/reducer';
import channels from 'redux/reducers/channels/reducer';
import dashboard from 'redux/reducers/dashboard/dashboard-reducer';
import download from 'redux/reducers/download/reducer';
import finance from 'redux/reducers/finance/finance-reducer';
import moderation from 'redux/reducers/moderation/reducer';
import mailer from 'redux/reducers/mailer/reducer';
import reactions from 'redux/reducers/reactions/reducer';
import referral from 'redux/reducers/referral/reducer';
import reports from 'redux/reducers/reports/reducer';
import reservedUsernames from 'redux/reducers/reserved/reducer';
import support from 'redux/reducers/support/reducer';
import transaction from 'redux/reducers/transaction/reducer';
import users from 'redux/reducers/users/reducer';
import utils from 'redux/reducers/utils/reducer';

export const rootReducer = combineReducers({
  auth,
  app,
  channels,
  users,
  transaction,
  reports,
  admins,
  support,
  aiServicese,
  reservedUsernames,
  utils,
  download,
  finance,
  referral,
  apkFiles,
  aiChatBots,
  reactions,
  dashboard,
  aiPrompts,
  moderation,
  mailer,
  advertising,
});
